// src/pages/Legal/TermsAndConditions.jsx
import React from "react";
import "./TermsAndConditions.css"

const TermsAndConditions = () => {
  return (
    <div className="legal-page-container">
      <h1>Terms & Conditions</h1>
      <p>
        <strong>Effective Date:</strong> January 7, 2026
      </p>

      <p>
        These Terms & Conditions govern your use of the BA Code Solution website
        and services. By accessing or using our platform, you agree to comply
        with these terms.
      </p>

      <h2>1. Use of Website</h2>
      <ul>
        <li>The content on this website is for informational purposes only.</li>
        <li>
          You agree not to misuse, copy, or distribute any content without
          written permission.
        </li>
        <li>Unauthorized use may result in legal action.</li>
      </ul>

      <h2>2. Services</h2>
      <p>
        BA Code Solution provides custom software development services,
        including web and mobile applications, ERP systems, and technology
        consulting. Project scope, timelines, and deliverables are defined
        through mutual agreement before project initiation.
      </p>

      <h2>3. Intellectual Property</h2>
      <p>
        All website content, designs, logos, code, and materials are the
        intellectual property of BA Code Solution unless stated otherwise.
        Clients retain ownership of their business data and project-specific
        assets as agreed upon contractually.
      </p>

      <h2>4. Confidentiality</h2>
      <p>
        Both parties agree to maintain confidentiality of business, technical,
        and project-related information shared during discussions or project
        execution.
      </p>

      <h2>5. Limitation of Liability</h2>
      <p>
        BA Code Solution shall not be liable for any indirect, incidental, or
        consequential damages, loss of data, profits, or issues caused by
        third-party services.
      </p>

      <h2>6. Third-Party Services</h2>
      <p>
        Our solutions may integrate third-party APIs or services. BA Code
        Solution is not responsible for the availability, performance, or
        policies of third-party providers.
      </p>

      <h2>7. Termination</h2>
      <p>
        We reserve the right to suspend or terminate access to our services if
        these terms are violated or misuse is identified.
      </p>

      <h2>8. Governing Law</h2>
      <p>
        These Terms & Conditions shall be governed and interpreted according to
        the applicable laws of India.
      </p>

      <h2>9. Changes to Terms</h2>
      <p>
        We may update these Terms & Conditions at any time. Continued use of our
        website or services implies acceptance of the updated terms.
      </p>

      <h2>10. Contact Information</h2>
      <p>
        For any questions, please reach out via our <strong>Contact Us</strong>{" "}
        page.
      </p>
    </div>
  );
};

export default TermsAndConditions;
